import React, { useState, useEffect } from 'react';
import {
  DollarSign, 
  Building2, 
  TrendingUp, 
  TrendingDown,
  Plus,
  Filter,
  Search,
  Calendar,
  FileText,
  BarChart3,
  PieChart,
  Download,
  Upload,
  Settings,
  AlertCircle,
  CheckCircle,
  Clock,
  Euro,
  Percent,
  Calculator,
  CreditCard,
  Home,
  Gavel,
  Megaphone,
  Eye,
  Edit,
  Trash2,
  X,
  Zap,
  Building,
  Users,
  Camera,
  Brain
} from 'lucide-react';
import UtilityBillingSection from "../components/UtilityBillingSection";
import UniversalSearch from "../components/UniversalSearch";
import { masterSupabase } from '../lib/supabase-master.js';
import AddCostModal from '../components/AddCostModal';
import UniversalDocumentUpload from '../components/UniversalDocumentUpload';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../components/notifications/ToastProvider';
import activityService from '../services/activityService';

const BewirtschaftungPage = () => {
  const [selectedProperty, setSelectedProperty] = useState("all");
  const [searchSelection, setSearchSelection] = useState(null);
  const [filteredProperty, setFilteredProperty] = useState(null);
  const [filteredTenant, setFilteredTenant] = useState(null);
  const [selectedTenant, setSelectedTenant] = useState("all");
  const [tenants, setTenants] = useState([]);
  const [selectedTimeframe, setSelectedTimeframe] = useState("current_year");
  const [selectedCostType, setSelectedCostType] = useState("all");
  const [costs, setCosts] = useState([]);
  const [properties, setProperties] = useState([]);
  const [kpis, setKpis] = useState({});
  const [costCategories, setCostCategories] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showIntelligentUpload, setShowIntelligentUpload] = useState(false);
  // Kosten-Matching
  const [costReviewCount, setCostReviewCount] = useState(0);
  const [showCostReview, setShowCostReview] = useState(false);
  const [costReviewItems, setCostReviewItems] = useState([]);
  const [costReviewLoading, setCostReviewLoading] = useState(false);
  const [costReviewPage, setCostReviewPage] = useState(1);
  const [costReviewTotal, setCostReviewTotal] = useState(0);
  const [selectedCostPropertyId, setSelectedCostPropertyId] = useState('');
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCost, setSelectedCost] = useState(null);
  const [costToDelete, setCostToDelete] = useState(null);
  const [editingCost, setEditingCost] = useState(null);
  const [bookingSuggestion, setBookingSuggestion] = useState(null);
  const [initialCostData, setInitialCostData] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
// Loading and UI states
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [allCosts, setAllCosts] = useState([]);
  const [filteredCosts, setFilteredCosts] = useState([]);
  const [typeLabels, setTypeLabels] = useState({});

  const { user, isAuthenticated } = useAuth();
  const { showError, showSuccess } = useToast();

  const handleSearchSelection = (selection) => {
    setSearchSelection(selection);
    
    if (selection === null) {
      setFilteredProperty(null);
      setFilteredTenant(null);
      return;
    }

    if (selection.type === "property") {
      setFilteredProperty(selection.data);
      setFilteredTenant(null);
    } else if (selection.type === "tenant") {
      setFilteredTenant(selection.data);
      setFilteredProperty(selection.data.property);
    }
  };

  // ✅ NEUE HANDLER FÜR OCR-INTEGRATION
  const handleIntelligentUploadComplete = (result) => {
    console.log('🚀 Intelligent upload completed:', result);
    
    // Wenn OCR-Analyse erfolgreich und Review nicht erforderlich
    if (result.ocrResult && !result.needsReview && result.ocrResult.auto_approved) {
      // Automatische Buchungsvorschlag-Erstellung
      const bookingSuggestion = {
        property_id: selectedProperty !== 'all' ? selectedProperty : null,
        cost_category: result.ocrResult.category,
        cost_type: 'operating',
        description: `${result.ocrResult.supplier_name || 'Rechnung'} - ${result.ocrResult.category}`,
        amount: result.ocrResult.amount,
        vat_rate: '19.00',
        invoice_number: result.ocrResult.invoice_number,
        invoice_date: result.ocrResult.date,
        supplier_name: result.ocrResult.supplier_name,
        document_id: result.document.id
      };
      
      handleBookingSuggestion(bookingSuggestion);
    } else {
      // OCR-Review erforderlich oder fehlgeschlagen
      setShowIntelligentUpload(false);
      fetchCosts(); // Refresh für neue Dokumente
    }
  };

  const handleBookingSuggestion = (suggestion) => {
    console.log('💡 Booking suggestion received:', suggestion);
    setBookingSuggestion(suggestion);
    
    // Collect OCR data for AddCostModal pre-filling
    const ocrData = {
      supplier_name: suggestion.supplier_name || "",
      invoice_number: suggestion.invoice_number || "",
      description: suggestion.description || "",
      net_amount: suggestion.net_amount || "",
      vat_rate: suggestion.vat_rate || "19.00",
      vat_amount: suggestion.vat_amount || "",
      gross_amount: suggestion.amount || "",
      invoice_date: suggestion.invoice_date || "",
      due_date: suggestion.due_date || "",
      category: suggestion.cost_category || suggestion.category || "",
      property_id: suggestion.property_id || ""
    };
    
    console.log('📋 OCR data for pre-filling:', ocrData);
    setInitialCostData(ocrData);
    
    // Open AddCostModal in CREATE mode with OCR data pre-filled
    setEditingCost(null);
    setShowIntelligentUpload(false);
    setShowAddModal(true);
  };


  const costTypeLabels = {
    notary: 'Notar',
    court_fees: 'Gerichtsgebühren',
    government_fees: 'Behördengebühren',
    broker_commission: 'Maklergebühren',
    registration_fees: 'Eintragungsgebühren',
    // Marketing
    advertising: 'Werbung',
    listing_fees: 'Inseratsgebühren',
    photography: 'Fotografie',
    staging: 'Home Staging',
    vacancy_loss: 'Leerstandskosten',
    broker_fees: 'Maklergebühren',
    online_portals: 'Online-Portale'
  };

  // Function to get German type label
  const getGermanTypeLabel = (englishType) => {
    return typeLabels[englishType] || englishType || 'Unbekannt';
  };

  // Function to handle view cost
  const handleViewCost = (cost) => {
    setSelectedCost(cost);
    setShowViewModal(true);
  };

  // Function to handle delete cost confirmation
  const handleDeleteCost = (cost) => {
    setCostToDelete(cost);
    setShowDeleteModal(true);
  };

  // Function to handle edit cost
  const handleEditCost = (cost) => {
    setEditingCost(cost);
    setShowAddModal(true);
  };

  // Function to confirm delete cost
  const confirmDeleteCost = async () => {
    if (!costToDelete) return;
    
    try {
      console.log('🗑️ Deleting cost:', costToDelete);
      
      const { error } = await masterSupabase
        .from(costToDelete.table_source)
        .delete()
        .eq('id', costToDelete.id);
      
      if (error) {
        console.error('❌ Error deleting cost:', error);
        showError('Fehler beim Löschen der Kosten. Bitte versuchen Sie es erneut.');
        return;
      }
      
      console.log('✅ Cost deleted successfully');
      
      // Activity-Logging vor dem Schließen des Modals
      await activityService.logCostDeleted(costToDelete);
      
      // Close modal and refresh data
      setShowDeleteModal(false);
      setCostToDelete(null);
      await fetchAllData();
      
      // Show success toast
      showSuccess('Kosten erfolgreich gelöscht!');
      
    } catch (error) {
      console.error('❌ Error in delete operation:', error);
      showError('Fehler beim Löschen der Kosten. Bitte versuchen Sie es erneut.');
    }
  };

  // Session synchronization function
  const ensureSupabaseSession = async () => {
    if (!isAuthenticated || !user) {
      console.log('User not authenticated, skipping session check');
      return false;
    }
    
    const { data: { session } } = await masterSupabase.auth.getSession();
    if (!session) {
      console.warn('No active Supabase session, user authenticated but session missing');
      return false;
    }
    
    console.log('Supabase session active for user:', session.user.id);
    return true;
  };
  // Secure backend fallback (no service key in frontend)
  const fetchDataViaBackend = async (endpoint, token) => {
    try {
      const response = await fetch(`/api/${endpoint}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Backend API error: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`Backend fallback failed for ${endpoint}:`, error);
      return null;
    }
  };


  // Fetch data from Supabase
  useEffect(() => {
    const initializeData = async () => {
      const sessionOk = await ensureSupabaseSession();
      if (sessionOk) {
        fetchAllData();
      } else {
        console.log('Skipping data fetch due to session issues');
        setLoading(false);
      }
    };
    
    initializeData();
    }, [selectedProperty, selectedTimeframe, isAuthenticated]);

  // Recalculate KPIs and categories when costs or filters change
  useEffect(() => {
    if (costs.length >= 0) { // Allow calculation even with 0 costs
      console.log('🔄 Recalculating KPIs and categories due to costs/filter change...');
      fetchKPIs();
      fetchCostCategories();
    }
  }, [costs, selectedProperty, properties]);

  // Kosten-Matching Funktionen
  const loadCostReviewCount = async () => {
    try {
      const res = await fetch('/api/costs/count');
      const data = await res.json();
      setCostReviewCount(data.count || 0);
    } catch (e) {
      console.warn('costReviewCount fetch failed:', e);
    }
  };

  const loadCostReviewItems = async (page = 1) => {
    setCostReviewLoading(true);
    try {
      const res = await fetch(`/api/costs/review?page=${page}&pageSize=20`);
      const data = await res.json();
      setCostReviewItems(data.data || []);
      setCostReviewTotal(data.pagination?.total || 0);
      setCostReviewPage(page);
    } catch (e) {
      console.error('loadCostReviewItems failed:', e);
    } finally {
      setCostReviewLoading(false);
    }
  };

  const handleCostApprove = async (ids) => {
    if (!selectedCostPropertyId) {
      alert('Bitte zuerst ein Objekt auswählen');
      return;
    }
    try {
      const res = await fetch('/api/costs/approve', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids, property_id: selectedCostPropertyId }),
      });
      const data = await res.json();
      if (data.status === 'ok') {
        showSuccess(`${data.inserted} Kosten gebucht`);
        loadCostReviewItems(costReviewPage);
        loadCostReviewCount();
        fetchCosts();
      } else {
        showError(data.error || 'Fehler beim Buchen');
      }
    } catch (e) {
      showError('Netzwerkfehler');
    }
  };

  const handleCostReject = async (ids) => {
    try {
      await fetch('/api/costs/reject', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids }),
      });
      loadCostReviewItems(costReviewPage);
      loadCostReviewCount();
    } catch (e) {
      showError('Fehler beim Ablehnen');
    }
  };

  const handleScanCosts = async () => {
    setCostReviewLoading(true);
    try {
      const res = await fetch('/api/costs/scan', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ limit: 500, min_confidence: 0.75 }),
      });
      const data = await res.json();
      showSuccess(`${data.inserted} neue Transaktionen erkannt`);
      loadCostReviewItems(1);
      loadCostReviewCount();
    } catch (e) {
      showError('Scan fehlgeschlagen');
    } finally {
      setCostReviewLoading(false);
    }
  };

  const fetchAllData = async () => {
    setLoading(true);
    try {
      // First load properties and costs
      await Promise.all([
        fetchProperties(),
        fetchCosts(),
        loadCostReviewCount()
      ]);
      // KPIs and categories will be calculated in separate useEffect after costs are loaded
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProperties = async () => {
    try {
      if (!user?.id) {
        console.log("🚫 No user ID available, cannot load properties");
        setProperties([]);
        return;
      }
      
      const { data, error } = await masterSupabase
        .from('properties')
        .select('id, property_name')
        .eq('created_by', user.id)
        .order('property_name');
      
      if (error) throw error;
      setProperties(data || []);
    } catch (error) {
      console.error('Error fetching properties:', error);
    }
  };

  const fetchCosts = async () => {
    try {
      if (!user?.id) {
        console.log("🚫 No user ID available, cannot load costs");
        setCosts([]);
        setAllCosts([]);
        setFilteredCosts([]);
        return;
      }
      
      console.log('🔄 Loading individual costs from category tables...');
      
      // Define cost categories and their tables
      const costTables = [
        { table: 'financing_costs', category: 'financing', category_name: 'Finanzierung' },
        { table: 'management_fees', category: 'management', category_name: 'Verwaltung' },
        { table: 'operating_costs', category: 'operating', category_name: 'Betrieb' },
        { table: 'legal_costs', category: 'legal', category_name: 'Recht & Steuern' },
        { table: 'marketing_costs', category: 'marketing', category_name: 'Marketing' }
      ];

      // Fetch costs from all category tables
      const allCosts = [];
      
      for (const { table, category, category_name } of costTables) {
        try {
          const { data, error } = await masterSupabase
            .from(table)
            .select(`
              *,
              properties:property_id (
                id,
                property_name
              )
            `)
            .eq('created_by', user.id)
          
          if (error) {
            console.warn(`⚠️ Error fetching from ${table}:`, error);
            continue;
          }
          
          // Transform data to unified format
          const transformedCosts = (data || []).map(cost => {
            console.log(`🔍 DEBUG: Cost from ${table}:`, cost);
            console.log(`🔍 DEBUG: cost.properties:`, cost.properties);
            
            return {
              id: cost.id,
              property_id: cost.property_id,
              properties: cost.properties, // Include the joined properties data
              category: category,
              category_name: category_name,
              cost_type: cost.cost_type || cost.fee_type || 'Unbekannt',
              description: cost.description || '',
              gross_amount: cost.gross_amount || 0,
              amount: cost.amount || cost.gross_amount || 0,
              vat_rate: cost.vat_rate || 0,
              frequency: cost.frequency || 'monthly',
              start_date: cost.start_date || cost.billing_period_start || cost.service_date,
              end_date: cost.end_date || cost.billing_period_end,
              is_active: cost.is_active !== false,
              created_at: cost.created_at,
              table_source: table,
              // Add missing fields for operating costs
              supplier_name: cost.supplier_name || '',
              invoice_number: cost.invoice_number || '',
              is_recoverable: cost.is_recoverable || false,
              recovery_percentage: cost.recovery_percentage || 0
            };
          });
          
          allCosts.push(...transformedCosts);
          console.log(`✅ Loaded ${transformedCosts.length} costs from ${table}`);
          
        } catch (tableError) {
          console.warn(`⚠️ Failed to fetch from ${table}:`, tableError);
        }
      }
      
      // Filter by property if selected
      const filteredCosts = selectedProperty === 'all' 
        ? allCosts
        : Array.isArray(allCosts) ? allCosts.filter(cost => cost.property_id === selectedProperty) : [];
      
      // Sort by creation date (newest first)
      filteredCosts.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      
      setCosts(filteredCosts);
      console.log(`✅ Total costs loaded: ${filteredCosts.length}`, filteredCosts);
      
    } catch (error) {
      console.error('❌ Error fetching individual costs:', error);
      setCosts([]);
    }
  };

  const fetchKPIs = async () => {
    try {
      console.log('🔄 Calculating KPIs from individual costs...', costs);
      
      // Filter costs based on selected property
      const filteredCosts = selectedProperty === 'all' 
        ? costs
        : Array.isArray(costs) ? costs.filter(cost => cost.property_id === selectedProperty) : [];
      
      console.log(`📊 Calculating KPIs for ${filteredCosts.length} costs (property filter: ${selectedProperty})`);
      
      // Calculate KPIs from filtered individual costs data
      let totalMonthlyAmount = 0;
      let totalYearlyAmount = 0;
      let oneTimeAmount = 0;
      
      filteredCosts.forEach(cost => {
        const amount = cost.gross_amount || 0;
        
        switch (cost.frequency) {
          case 'monthly':
            totalMonthlyAmount += amount;
            totalYearlyAmount += amount * 12;
            break;
          case 'yearly':
            totalYearlyAmount += amount;
            break;
          case 'one-time':
            oneTimeAmount += amount;
            break;
          default:
            // Assume monthly if frequency is unclear
            totalMonthlyAmount += amount;
            totalYearlyAmount += amount * 12;
        }
      });

      // Calculate average cost per property
      const relevantProperties = selectedProperty === 'all' ? properties : Array.isArray(properties) ? properties.filter(p => p.id === selectedProperty) : [];
      const avgCostPerProperty = relevantProperties.length > 0 ? totalYearlyAmount / relevantProperties.length : 0;

      setKpis({
        totalCosts: totalYearlyAmount + oneTimeAmount, // Total annual + one-time
        monthlyRecurring: totalMonthlyAmount, // Monthly recurring costs
        yearlyOneTime: oneTimeAmount, // One-time costs this year
        avgCostPerProperty: avgCostPerProperty, // Average annual cost per property
        costTrend: 5.2 // TODO: Calculate from historical data
      });

      console.log('✅ KPIs calculated from filtered costs:', {
        totalCosts: totalYearlyAmount + oneTimeAmount,
        monthlyRecurring: totalMonthlyAmount,
        yearlyOneTime: oneTimeAmount,
        avgCostPerProperty: avgCostPerProperty,
        filteredCostsCount: filteredCosts.length,
        propertyFilter: selectedProperty
      });
    } catch (error) {
      console.error('❌ Error calculating KPIs:', error);
    }
  };

  const fetchCostCategories = async () => {
    try {
      console.log('🔄 Calculating cost categories from individual costs...', costs);
      
      // Filter costs based on selected property
      const filteredCosts = selectedProperty === 'all' 
        ? costs
        : Array.isArray(costs) ? costs.filter(cost => cost.property_id === selectedProperty) : [];
      
      console.log(`📊 Calculating categories for ${filteredCosts.length} costs (property filter: ${selectedProperty})`);
      
      // Calculate category totals from filtered individual costs data
      const categories = [
        {
          id: 'financing',
          name: 'Finanzierung',
          icon: CreditCard,
          color: 'blue',
          description: 'Zinsen, Tilgung, Kreditgebühren'
        },
        {
          id: 'management',
          name: 'Verwaltung',
          icon: Home,
          color: 'green',
          description: 'Property Management, Administration'
        },
        {
          id: 'operating',
          name: 'Betrieb',
          icon: Settings,
          color: 'orange',
          description: 'Grundsteuer, Versicherung, Hausmeister'
        },
        {
          id: 'legal',
          name: 'Recht & Steuern',
          icon: Gavel,
          color: 'purple',
          description: 'Anwalt, Notar, Behördengebühren'
        },
        {
          id: 'marketing',
          name: 'Marketing',
          icon: Megaphone,
          color: 'pink',
          description: 'Vermarktung, Leerstandskosten'
        },
        {
          id: 'suppliers',
          name: 'Versorger',
          icon: Zap,
          color: 'yellow',
          description: 'Strom, Gas, Wasser, Internet'
        }
      ];

      const categoriesWithData = categories.map(category => {
        const categoryCosts = Array.isArray(filteredCosts) ? filteredCosts.filter(cost => cost.category === category.id) : [];
        
        // Calculate annual amount for this category
        let annualAmount = 0;
        categoryCosts.forEach(cost => {
          const amount = cost.gross_amount || 0;
          switch (cost.frequency) {
            case 'monthly':
              annualAmount += amount * 12;
              break;
            case 'yearly':
              annualAmount += amount;
              break;
            case 'one-time':
              annualAmount += amount;
              break;
            default:
              // Assume monthly if frequency is unclear
              annualAmount += amount * 12;
          }
        });

        // Calculate percentage of total costs
        const totalAmount = kpis.totalCosts || 1; // Avoid division by zero
        const percentage = totalAmount > 0 ? (annualAmount / totalAmount) * 100 : 0;

        return {
          ...category,
          amount: annualAmount,
          percentage,
          trend: Math.random() * 10 - 5 // TODO: Calculate from historical data
        };
      });

      setCostCategories(categoriesWithData);
      console.log('✅ Cost categories calculated:', categoriesWithData);
    } catch (error) {
      console.error('❌ Error calculating cost categories:', error);
    }
  };

  // Utility functions
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };

  const formatTrend = (trend) => {
    const isPositive = trend > 0;
    const Icon = isPositive ? TrendingUp : TrendingDown;
    const colorClass = isPositive ? 'text-red-600' : 'text-green-600';
    
    return (
      <div className={`flex items-center €{colorClass}`}>
        <Icon className="w-4 h-4 mr-1" />
        <span className="text-sm font-medium">{Math.abs(trend).toFixed(1)}%</span>
      </div>
    );
  };

  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'bg-blue-500/10 text-blue-600 border-blue-200',
      green: 'bg-green-500/10 text-green-600 border-green-200',
      orange: 'bg-orange-500/10 text-orange-600 border-orange-200',
      purple: 'bg-purple-500/10 text-purple-600 border-purple-200',
      pink: 'bg-pink-500/10 text-pink-600 border-pink-200',
      yellow: 'bg-yellow-500/10 text-yellow-600 border-yellow-200'
    };
    return colorMap[color] || colorMap.blue;
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'paid':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">Bezahlt</span>;
      case 'pending':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">Ausstehend</span>;
      case 'overdue':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">Überfällig</span>;
      default:
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-black dark:text-gray-200">Unbekannt</span>;
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-white dark:bg-black flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Lade Bewirtschaftungsdaten...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white dark:bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center">
                <Euro className="w-8 h-8 mr-3 text-blue-600" />
                Bewirtschaftung
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mt-2">
                Kostenmanagement und Bewirtschaftungsanalysen
              </p>
            </div>
            <div className="flex space-x-3">
              <button className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-slate-900 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                <Download className="w-4 h-4 mr-2" />
                Export
              </button>
              
              {/* Intelligente Rechnungserfassung */}
              <button 
                onClick={() => setShowIntelligentUpload(true)}
                className="inline-flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm font-medium transition-colors"
              >
                <Camera className="w-4 h-4 mr-2" />
                Rechnung fotografieren
              </button>
              
              {/* Kosten-Matching Button */}
              <button
                onClick={() => { setShowCostReview(true); loadCostReviewItems(1); }}
                className="inline-flex items-center px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm font-medium transition-colors relative"
              >
                <Brain className="w-4 h-4 mr-2" />
                Kosten-Matching
                {costReviewCount > 0 && (
                  <span className="ml-2 bg-white text-purple-700 text-xs font-bold px-1.5 py-0.5 rounded-full">
                    {costReviewCount}
                  </span>
                )}
              </button>

              {/* Manueller Button */}
              <button 
                onClick={() => setShowAddModal(true)}
                className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors"
              >
                <Plus className="w-4 h-4 mr-2" />
                Manuell hinzufügen
              </button>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="mb-8 grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <select 
              value={selectedProperty} 
              onChange={(e) => setSelectedProperty(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-slate-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="all">Alle Objekte</option>
              {properties.map(property => (
                <option key={property.id} value={property.id}>
                  {property.property_name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <select 
              value={selectedTimeframe} 
              onChange={(e) => setSelectedTimeframe(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-slate-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="month">Aktueller Monat</option>
              <option value="quarter">Aktuelles Quartal</option>
              <option value="year">Aktuelles Jahr</option>
              <option value="custom">Benutzerdefiniert</option>
            </select>
          </div>
          <div>
            <select 
              value={selectedCostType} 
              onChange={(e) => setSelectedCostType(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-slate-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="all">Alle Kostenarten</option>
              <option value="financing">Finanzierung</option>
              <option value="management">Verwaltung</option>
              <option value="operating">Betrieb</option>
              <option value="legal">Recht & Steuern</option>
              <option value="marketing">Marketing</option>
              <option value="suppliers">Versorger</option>
            </select>
          </div>
          <div>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
              <input
                type="text"
                placeholder="Kosten durchsuchen..."
                className="w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-slate-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Gesamtkosten p.a.</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
                  {formatCurrency(kpis.totalCosts)}
                </p>
              </div>
              <div className="p-3 bg-blue-500/10 rounded-lg">
                <Euro className="w-6 h-6 text-blue-600" />
              </div>
            </div>
            <div className="mt-4">
              {formatTrend(kpis.costTrend)}
            </div>
          </div>

          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Monatliche Kosten</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
                  {formatCurrency(kpis.monthlyRecurring)}
                </p>
              </div>
              <div className="p-3 bg-green-500/10 rounded-lg">
                <Calendar className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="mt-4">
              <span className="text-sm text-gray-600 dark:text-gray-400">
                {formatCurrency(kpis.monthlyRecurring * 12)} / Jahr
              </span>
            </div>
          </div>

          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Einmalige Kosten YTD</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
                  {formatCurrency(kpis.yearlyOneTime)}
                </p>
              </div>
              <div className="p-3 bg-orange-500/10 rounded-lg">
                <FileText className="w-6 h-6 text-orange-600" />
              </div>
            </div>
            <div className="mt-4">
              <span className="text-sm text-gray-600 dark:text-gray-400">Dieses Jahr</span>
            </div>
          </div>

          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Ø Kosten/Objekt</p>
                <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
                  {formatCurrency(kpis.avgCostPerProperty)}
                </p>
              </div>
              <div className="p-3 bg-purple-500/10 rounded-lg">
                <Calculator className="w-6 h-6 text-purple-600" />
              </div>
            </div>
            <div className="mt-4">
              <span className="text-sm text-gray-600 dark:text-gray-400">Pro Jahr</span>
            </div>
          </div>
        </div>
        {/* Utility Billing Section */}
        <UtilityBillingSection />



        {/* Cost Categories */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Kostenkategorien</h2>
            <div className="flex space-x-2">
              <button className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                <BarChart3 className="w-5 h-5" />
              </button>
              <button className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                <PieChart className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {costCategories.map((category) => {
              const Icon = category.icon;
              const isSuppliers = category.id === 'suppliers';
              
              const CardContent = () => (
                <>
                  <div className="flex items-center justify-between mb-4">
                    <div className={`p-3 rounded-lg €{getColorClasses(category.color)}`}>
                      <Icon className="w-6 h-6" />
                    </div>
                    {formatTrend(category.trend)}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                    {category.name}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                    {category.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-2xl font-bold text-gray-900 dark:text-white">
                      {isSuppliers ? 'Zur Verwaltung' : formatCurrency(category.amount)}
                    </span>
                    <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
                      {isSuppliers ? '→' : `${category.percentage.toFixed(1)}%`}
                    </span>
                  </div>
                </>
              );
              
              if (isSuppliers) {
                return (
                  <div 
                    key={category.id} 
                    onClick={() => window.location.href = '/suppliers'}
                    className="bg-gradient-to-br from-yellow-50 to-yellow-100 dark:from-yellow-900/20 dark:to-yellow-800/20 rounded-xl shadow-lg border-2 border-yellow-300 dark:border-yellow-600 p-6 cursor-pointer hover:shadow-xl transition-all duration-300 transform hover:scale-105 ring-2 ring-yellow-200 dark:ring-yellow-700"
                  >
                    <CardContent />
                  </div>
                );
              }
              
              return (
                <div key={category.id} className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
                  <CardContent />
                </div>
              );
            })}
          </div>
        </div>

        {/* Current Costs Table */}
        <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
          <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Aktuelle Kosten</h2>
              <button className="text-blue-600 hover:text-blue-700 text-sm font-medium">
                Alle anzeigen
              </button>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 dark:bg-slate-800">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Objekt
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Kategorie
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Typ
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Lieferant
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Bruttobetrag
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Datum
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Aktionen
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-slate-900 divide-y divide-gray-200 dark:divide-gray-700">
                {costs.slice(0, 10).map((cost) => (
                  <tr 
                    key={cost.id} 
                    className="hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
                    onClick={() => handleViewCost(cost)}
                    title="Kosten ansehen"
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900 dark:text-white">
                        {cost.properties?.property_name || 'Unbekannt'}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium €{getColorClasses(
                        cost.category === 'financing' ? 'blue' :
                        cost.category === 'management' ? 'green' :
                        cost.category === 'operating' ? 'orange' :
                        cost.category === 'legal' ? 'purple' : 
                        cost.category === 'suppliers' ? 'yellow' : 'pink'
                      )}`}>
                        {cost.category_name}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                      {getGermanTypeLabel(cost.cost_type)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                      {cost.supplier_name || 'Nicht angegeben'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">
                      {formatCurrency(cost.gross_amount)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                      {cost.start_date ? new Date(cost.start_date).toLocaleDateString('de-DE') : '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {getStatusBadge('paid')} {/* TODO: Add status field to schema */}
                    </td>
                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex space-x-2">
                        <button 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewCost(cost);
                          }}
                          className="text-blue-600 hover:text-blue-900 dark:hover:text-blue-400"
                          title="Kosten ansehen"
                        >
                          <Eye className="w-4 h-4" />
                        </button>
                        <button 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditCost(cost);
                          }}
                          className="text-gray-600 hover:text-gray-900 dark:hover:text-gray-400"
                          title="Kosten bearbeiten"
                        >
                          <Edit className="w-4 h-4" />
                        </button>
                        <button 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteCost(cost);
                          }}
                          className="text-red-600 hover:text-red-900 dark:hover:text-red-400"
                          title="Kosten löschen"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add Cost Modal */}
      <AddCostModal
        isOpen={showAddModal}
        onClose={() => {
          setShowAddModal(false);
          setEditingCost(null);
          setInitialCostData(null);
        }}
        onSuccess={async (savedCost) => {
          await fetchAllData();
          showSuccess(editingCost ? 'Kosten erfolgreich aktualisiert!' : 'Kosten erfolgreich gespeichert!');
          
          // Activity-Logging
          if (savedCost) {
            if (editingCost) {
              await activityService.logCostUpdated(savedCost);
            } else {
              await activityService.logCostCreated(savedCost);
            }
          }
          setEditingCost(null);
          setInitialCostData(null);
        }}
        properties={properties}
        editingCost={editingCost}
        initialData={initialCostData}
      />

      {/* View Cost Modal */}
      {showViewModal && selectedCost && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                  Kostendetails
                </h2>
                <button
                  onClick={() => setShowViewModal(false)}
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>
            
            <div className="px-6 py-4 space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Objekt
                  </label>
                  <p className="mt-1 text-sm text-gray-900 dark:text-white">
                    {selectedCost.properties?.property_name || 'Unbekannt'}
                  </p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Kategorie
                  </label>
                  <p className="mt-1 text-sm text-gray-900 dark:text-white">
                    {selectedCost.category_name}
                  </p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Typ
                  </label>
                  <p className="mt-1 text-sm text-gray-900 dark:text-white">
                    {getGermanTypeLabel(selectedCost.cost_type)}
                  </p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Bruttobetrag
                  </label>
                  <p className="mt-1 text-lg font-semibold text-gray-900 dark:text-white">
                    {formatCurrency(selectedCost.gross_amount)}
                  </p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Häufigkeit
                  </label>
                  <p className="mt-1 text-sm text-gray-900 dark:text-white">
                    {selectedCost.frequency === 'monthly' ? 'Monatlich' : 
                     selectedCost.frequency === 'yearly' ? 'Jährlich' : 
                     selectedCost.frequency === 'one-time' ? 'Einmalig' : selectedCost.frequency}
                  </p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Startdatum
                  </label>
                  <p className="mt-1 text-sm text-gray-900 dark:text-white">
                    {selectedCost.start_date ? new Date(selectedCost.start_date).toLocaleDateString('de-DE') : '-'}
                  </p>
                </div>
              </div>
              
              {selectedCost.description && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Beschreibung
                  </label>
                  <p className="mt-1 text-sm text-gray-900 dark:text-white">
                    {selectedCost.description}
                  </p>
                </div>
              )}
              
              <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
                <div className="grid grid-cols-2 gap-4 text-xs text-gray-500 dark:text-gray-400">
                  <div>
                    <span className="font-medium">Quelle:</span> {selectedCost.table_source}
                  </div>
                  <div>
                    <span className="font-medium">Erstellt:</span> {selectedCost.created_at ? new Date(selectedCost.created_at).toLocaleDateString('de-DE') : '-'}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
              <div className="flex justify-end">
                <button
                  onClick={() => setShowViewModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-slate-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  Schließen
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Cost Confirmation Modal */}
      {showDeleteModal && costToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-xl max-w-md w-full mx-4">
            <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                  Kosten löschen
                </h2>
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>
            
            <div className="px-6 py-4">
              <div className="flex items-center mb-4">
                <div className="flex-shrink-0">
                  <AlertCircle className="w-8 h-8 text-red-600" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                    Kosteneintrag löschen?
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Möchten Sie diesen Kosteneintrag wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.
                  </p>
                </div>
              </div>
              
              <div className="bg-gray-50 dark:bg-slate-800 rounded-lg p-4">
                <div className="text-sm">
                  <div className="font-medium text-gray-900 dark:text-white">
                    {costToDelete.properties?.property_name || 'Unbekannt'}
                  </div>
                  <div className="text-gray-600 dark:text-gray-400">
                    {costToDelete.category_name} - {getGermanTypeLabel(costToDelete.cost_type)}
                  </div>
                  <div className="font-semibold text-gray-900 dark:text-white">
                    {formatCurrency(costToDelete.gross_amount)}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
              <div className="flex justify-end space-x-3">
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-slate-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  Abbrechen
                </button>
                <button
                  onClick={confirmDeleteCost}
                  className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  Ja, löschen
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Kosten-Matching Modal */}
      {showCostReview && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
              <div>
                <h2 className="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
                  <Brain className="w-5 h-5 text-purple-600" />
                  Kosten-Matching
                </h2>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
                  {costReviewTotal} Transaktionen erkannt – Objekt auswählen und buchen
                </p>
              </div>
              <button onClick={() => setShowCostReview(false)} className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Objekt-Auswahl + Scan */}
            <div className="px-6 py-3 border-b border-gray-200 dark:border-gray-700 flex items-center gap-4">
              <div className="flex-1">
                <label className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 block">Objekt für Buchung</label>
                <select
                  value={selectedCostPropertyId}
                  onChange={(e) => setSelectedCostPropertyId(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-slate-800 text-gray-900 dark:text-white text-sm"
                >
                  <option value="">-- Objekt wählen --</option>
                  {properties.map(p => (
                    <option key={p.id} value={p.id}>{p.property_name}</option>
                  ))}
                </select>
              </div>
              <button
                onClick={handleScanCosts}
                disabled={costReviewLoading}
                className="mt-5 px-4 py-2 bg-purple-600 hover:bg-purple-700 disabled:opacity-50 text-white rounded-lg text-sm font-medium"
              >
                {costReviewLoading ? 'Scannt...' : 'Neu scannen'}
              </button>
            </div>

            {/* Liste */}
            <div className="flex-1 overflow-y-auto px-6 py-4">
              {costReviewLoading ? (
                <div className="text-center py-12 text-gray-400">Lade...</div>
              ) : costReviewItems.length === 0 ? (
                <div className="text-center py-12 text-gray-400">
                  <CheckCircle className="w-12 h-12 mx-auto mb-3 text-green-400" />
                  <p>Keine offenen Kosten-Matches</p>
                  <button onClick={handleScanCosts} className="mt-3 text-purple-600 hover:underline text-sm">Jetzt scannen</button>
                </div>
              ) : (
                <div className="space-y-2">
                  {costReviewItems.map(item => (
                    <div key={item.id} className="flex items-center gap-4 p-3 rounded-lg bg-gray-50 dark:bg-slate-800/50 border border-gray-200 dark:border-gray-600">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-0.5">
                          <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300">
                            {item.label}
                          </span>
                          {item.recoverable && (
                            <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300">umlagefähig</span>
                          )}
                          <span className="text-xs text-gray-400">{Math.round(item.confidence * 100)}% Konfidenz</span>
                        </div>
                        <div className="font-medium text-gray-900 dark:text-white text-sm truncate">{item.counterpart_name || '–'}</div>
                        <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{item.purpose || '–'}</div>
                      </div>
                      <div className="text-right shrink-0">
                        <div className="font-semibold text-gray-900 dark:text-white">
                          {item.amount ? `${Math.abs(item.amount).toLocaleString('de-DE', {minimumFractionDigits:2})} €` : '–'}
                        </div>
                        <div className="text-xs text-gray-400">{item.booking_date || '–'}</div>
                      </div>
                      <div className="flex gap-2 shrink-0">
                        <button
                          onClick={() => handleCostApprove([item.id])}
                          disabled={!selectedCostPropertyId}
                          className="px-3 py-1.5 bg-green-600 hover:bg-green-700 disabled:opacity-40 text-white text-xs rounded-lg font-medium"
                        >
                          Buchen
                        </button>
                        <button
                          onClick={() => handleCostReject([item.id])}
                          className="px-3 py-1.5 bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-500 text-gray-700 dark:text-gray-300 text-xs rounded-lg font-medium"
                        >
                          Ablehnen
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Pagination + Alle buchen */}
            {costReviewItems.length > 0 && (
              <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between">
                <div className="flex gap-2">
                  <button
                    onClick={() => loadCostReviewItems(costReviewPage - 1)}
                    disabled={costReviewPage <= 1}
                    className="px-3 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg disabled:opacity-40"
                  >
                    ←
                  </button>
                  <span className="text-sm text-gray-500 dark:text-gray-400 py-1.5">Seite {costReviewPage} / {Math.ceil(costReviewTotal / 20)}</span>
                  <button
                    onClick={() => loadCostReviewItems(costReviewPage + 1)}
                    disabled={costReviewPage >= Math.ceil(costReviewTotal / 20)}
                    className="px-3 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg disabled:opacity-40"
                  >
                    →
                  </button>
                </div>
                <button
                  onClick={() => handleCostApprove(costReviewItems.map(i => i.id))}
                  disabled={!selectedCostPropertyId || costReviewLoading}
                  className="px-4 py-2 bg-green-600 hover:bg-green-700 disabled:opacity-40 text-white text-sm rounded-lg font-medium"
                >
                  Alle {costReviewItems.length} buchen
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Intelligente Rechnungserfassung Modal */}
      <UniversalDocumentUpload
        documentType="invoice"
        mode="create"
        editingCost={null}
        isOpen={showIntelligentUpload}
        onClose={() => setShowIntelligentUpload(false)}
        onUploadComplete={handleIntelligentUploadComplete}
        onBookingSuggestion={handleBookingSuggestion}
      />
    </div>
  );
};

export default BewirtschaftungPage;

